import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Data } from '../models/titulo.model';

@Injectable({
  providedIn: 'root'
})
export class EntidadesService {

  private UrlEndPoint = environment.serverIntegracion;
  private ApiCross = environment.severApiCross;
  private serverUrl = environment.serverUrl;

  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  public titulos: Data[] = []

  constructor(private http: HttpClient) { }

  // Servicio para obtner entidad (TBL_AUTORIDAD) a partir del nombre
  getEntitybyName(entityName): Observable<any> {
    return this.http.post<any>(this.UrlEndPoint + "ObtenerEntidadPorNombre", '\"' + entityName + '\"', this.httpOptions);
  }

  getEntidades() {
    try {
      return this.http.get<any>(`${this.serverUrl}ramas`)
    } catch (error) {
      console.log("Error getEntidades --> " + error);
      return null;
    }
  }

  getTituloPrimeraSeccion() {
    try {
      return this.http.get<any>(`${this.serverUrl}secciones/primera-seccion `)
    } catch (error) {
      console.log("Error getEntidades --> " + error);
      return null;
    }
  }
}
